import axios from "axios";
import { store } from ".";
import {
  setToken,
  setRefreshToken,
  logout,
  disconnect,
} from "./slice/auth/AuthSlice";

const Interceptor = axios.create({
  timeout: 30000,
});

/* =========================
   REQUEST INTERCEPTOR
========================= */
Interceptor.interceptors.request.use(
  (config) => {
    const { token, refreshToken } = store.getState().authentification;

    config.headers = {
      ...config.headers,
      Accept: "application/json",
    };

    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (refreshToken) {
      config.headers["x-refresh-token"] = refreshToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* =========================
   RESPONSE INTERCEPTOR
========================= */
Interceptor.interceptors.response.use(
  (response) => {
    const newAccessToken = response.headers["authorization"];
    const newRefreshToken = response.headers["x-refresh-token"];

    if (newAccessToken) {
      store.dispatch(
        setToken({
          token: newAccessToken.replace("Bearer ", ""),
        })
      );
    }

    if (newRefreshToken) {
      store.dispatch(
        setRefreshToken({
          refreshToken: newRefreshToken,
        })
      );
    }

    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // 🔒 session expired → force logout
    // if (error.response?.status === 403 && !originalRequest?._retry) {
    if (error.response?.data?.msg =="Session expired. Please log in again." && !originalRequest?._retry) {      
    store.dispatch(disconnect());
    }

    return Promise.reject(error);
  }
);

export default Interceptor;
